<template>
  <y-view :loading="isLoading">
    <y-form titleAlign="left" titleWidth="100px" contentWidth="600px">
      <template>
        <y-form-item title="物料编码：" required>
          {{ editPara.goodsCode }}
        </y-form-item>
        <y-form-item title="仓库：" required>
          {{ editPara.wsname }}
        </y-form-item>
        <y-form-item title="售卖方式：" required>
          <div>
            <k-radio v-model="editPara.isMixSale" value="1">混卖</k-radio>
            <k-radio v-model="editPara.isMixSale" value="0">指定批次</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="我方批次号：" required v-if="editPara.isMixSale == '1' && editPara.saleBatchNoList.length > 0">
          {{ editPara.saleBatchNoList.map((s) => s.batchNo).join(",") }}
        </y-form-item>
        <y-form-item title="我方批次号：" required v-if="editPara.isMixSale == '0'">
          <k-select2
            block
            v-model="editPara.saleBatchNoList"
            :data="batchList"
            text-field="batchNo"
            key-field="batchNo"
            search-field="batchNo"
            layer-width="auto"
            layerMinWidthEqual
            placeholder="请选择我方批次号"
          >
          </k-select2>
        </y-form-item>
        <y-form-item title="商品名称：" required align="top">
          <k-input clearable placeholder="请输入商品名称" type="search" v-model="editPara.goodsNameSale" block> </k-input>
        </y-form-item>
        <y-form-item title="商品供货规格：" required align="top">
          <ol class="ml-2">
            <li v-for="(item, index) in editPara.packList" :key="index" class="mb-1" style="list-style: decimal;">
              规格数量：<k-input :disabled="isView" placeholder="请输入数量" style="max-width: 100px;" v-model="editPara.packList[index].quantity" type="number" min="1"> </k-input> ，
              起购数量：<k-input :disabled="isView" placeholder="请输入数量" style="max-width: 100px;" v-model="editPara.packList[index].startQuantity" type="number" min="1"> </k-input> ，
              限购数量：<k-input :disabled="isView" placeholder="请输入数量" style="max-width: 100px;" v-model="editPara.packList[index].limitQuantity" type="number" min="1"> </k-input>
              <span class="ml-2" v-if="!isView">
                <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAdd"></a>&nbsp;
                <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDel(index)" v-if="index > 0"></a>
              </span>
            </li>
          </ol>
        </y-form-item>
        <y-form-item title="经营模式：" required align="top">
          {{ editPara.manTypeName }}
        </y-form-item>
        <y-form-item title="贸易模式：" required align="top">
          {{ editPara.tradeTypeName }}
        </y-form-item>
        <y-form-item title="库位类型：" required align="top">
          {{ editPara.wltypeName }}
        </y-form-item>
        <y-form-item title="质量状态：" required align="top">
          {{ editPara.qualityTypeName }}
        </y-form-item>
      </template>
    </y-form>
    <div slot="bottom">
      <k-button @click="onCancel">{{ isView ? "返回" : "取消" }}</k-button>
      <k-button type="primary" v-if="!isView" :disabled="saveButtonStatus" @click="onSave">保存</k-button>
    </div>
  </y-view>
</template>

<script>
/**
 * @name:
 * @description: 新增自营批次
 * @author: zhaoliubin@yuouhui.com
 * @create: 2020-09-14 15:30:41
 * @update: 2020-09-14 15:30:41
 */
export default {
  data() {
    return {
      isLoading: false,
      packCell: {
        quantity: 1,
        limitQuantity: 1,
        startQuantity: 1,
      },
      editPara: {
        goodsNameSale: "",
        saleBatchNoList: [],
        packList: [],
        isMixSale: "",
      },
      batchList: [],
      id: "",
      isSaving: false,
      isView: false,
      isEdit: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    initPageData() {
      this.isLoading = true;
      this.$fetch({
        api: "/nestle-supply-back-server/ss/detail",
        para: { id: this.id },
      })
        .then((res) => {
          this.isLoading = false;
          this.editPara = res;
          this.batchList = this.editPara.saleBatchVoList;
          let list = [];
          res.saleBatchVoList.forEach((s) => {
            if (s.isSelected == true) {
              list.push(s.batchNo);
            }
          });
          this.editPara.saleBatchNoList = list;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onAdd() {
      this.editPara.packList.push(Object.assign({}, this.packCell));
    },
    onDel(index) {
      this.editPara.packList.splice(index, 1);
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "selfsupportList",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onSave() {
      if (this.isSaving) {
        return;
      }
      if (this.$validatorManu.isEmpty(this.editPara.goodsNameSale)) {
        return this.$root.tip("请输入商品名称");
      }
      if (this.$validatorManu.isEmpty(this.editPara.isMixSale)) {
        return this.$root.tip("请选择售卖方式");
      }
      if (this.editPara.isMixSale == "1") {
        this.editPara.saleBatchNoList = [];
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      for (let i = 0; i < para.packList.length; i++) {
        if (!para.packList[i]["quantity"] || !para.packList[i]["startQuantity"] || !para.packList[i]["limitQuantity"]) {
          return this.$root.tip(`第${i + 1}条所有数量输入框为必填项`);
        }
        if (para.packList[i]["limitQuantity"] - para.packList[i]["startQuantity"] < 0) {
          return this.$root.tip(`第${i + 1}条限购数应大于等于起购数量`);
        }
      }
      let api = this.id ? "/nestle-supply-back-server/ss/update" : "/nestle-supply-back-server/ss/save";
      this.isSaving = true;
      this.isLoading = true;
      this.$fetch({
        api,
        para: {
          goodsCode: para.goodsCode,
          goodsNameSale: para.goodsNameSale,
          isMixSale: para.isMixSale,
          packList: para.packList,
          wscode: para.wscode,
          saleBatchNoList: para.saleBatchNoList,
          id: this.id,
        },
        isSuccessTip: true,
      })
        .then(() => {
          this.isLoading = false;
          this.isSaving = false;
          setTimeout(this.onCancel, 1000);
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
    initPage() {
      if (this.id) {
        this.initPageData();
      } else {
        this.editPara.packList = [];
        Vue.lf.getItem("objSSAdd").then((d) => {
          this.editPara = Object.assign(this.editPara, d);
          this.editPara.packList.push(Object.assign({}, this.packCell));
          this.batchList = this.editPara.saleBatchVoList;
        });
      }
    },
  },
  created() {
    ({ id: this.id, isView: this.isView } = this.$route.query);
    this.initPage();
  },
  beforeRouteUpdate(to, from, next) {
    ({ id: this.id, isView: this.isView } = to.query);
    this.initPage();
  },
};
</script>

<style lang="postcss" module="css"></style>
